$(document).ready(function () {

  window.defaultNav = $('#mainNavigation').clone();


  $('#siteInfoBannerWidget #eventName').prependTo('#countdown-timer');
  if ($(window).width() < 801) {
    $('.countdown-wrapper').prependTo('.countdown-container');
    $('#cardWidgetButton').prependTo('.navigation-container');
    $('body:not(.homepage) .countdown-wrapper').insertAfter('.navigation-container');

  } else {
    $('.countdown-wrapper').prependTo('.header-right');
    $('#cardWidgetButton').insertBefore('.mobile-nav-toggle');
    $('body:not(.homepage) .countdown-wrapper').prependTo('.header-right');
  }

  // Hero Images
  const heroHTML = '<div class="hero-wrapper" style="background-image: url()"></div>';

  if (!$('body').hasClass('homepage')) {
    $(heroHTML).prependTo('.wrapper');
  }

  let dynamicHero = () => {
    const image = $('.entityContainer .entityContainerRow.rowIndex-1').find('.imageModule-single img').attr('data-src');

    const imageSrc = image.replace(/(?=[() ])/g, '\\');

    $('.hero-wrapper').css('background-image', 'url(' + imageSrc + ')');

  }

  let staticHero = () => {
    $('.hero-wrapper').css('background-image', 'url(' + `${FULLCLIENTTHEMEPATH}images/underwater.jpg` + ')');


  }

  if ($('body').hasClass('subpage-theme')) {
    $('body').removeClass('default');
    dynamicHero();
  }

  if ($('body').hasClass('default')) {
    staticHero();
  }

  
  // NAVIGATION 

  let nx = 0;

  function customNavStructure() {

    if (nx === 1) {
      return false;

    } else if (nx === 0) {

      // Navigation links

      function createOuterColumns() {
        $('#mainNavigation .mainNavigationItem1 .navClonedItem').remove();
        var firstNavGroupItems = $('#mainNavigation .mainNavigationItem1 > .items > .item');
        firstNavGroupItems.splice(0,3);
        firstNavGroupItems.wrapAll('<li class="normal-col"></li>');
        $('#mainNavigation .mainNavigationItem1 .normal-col > li').wrapAll('<ul class="subitems"></ul>');
      }

      createOuterColumns()

      function createColumns(items, itemsWrapper) {
        console.log(items.length);

        var itemAmount = items.length;

        function columnWrap(perCol) {
          if (itemAmount > perCol) {
            for (var i = 0; i < itemAmount; i += perCol) {
              items.slice(i, i + perCol).wrapAll('<ul class="multi-columns__column"></ul>');
            }
            itemsWrapper.attr('style', 'width:' + 225 * itemsWrapper.find('.multi-columns__column').length + 'px');
            itemsWrapper.addClass('multi-columns');
            itemsWrapper.parent('.item').css('width', 'auto');
            itemsWrapper.parent('.item').addClass('has-multi-columns');
          }
        }

        if (itemAmount <= 16) {
          columnWrap(8);
        } else {
          columnWrap(12);
        }

      }

      var innerColumnsItems = $('#mainNavigation .mainNavigationItem1 > .items > .item:nth-child(2) > .subitems > .item');
      var innerColumnsItemsWrapper = $('#mainNavigation .mainNavigationItem1 > .items > .item:nth-child(2) > .subitems');

      createColumns(innerColumnsItems, innerColumnsItemsWrapper);

      window.megaNav = $('#mainNavigation').clone();
      nx = 2;

    }
  }

  function handleNav() {
    if ($('body').hasClass('saffireLargeSize')) {
      if (nx === 2) {
        $('#mainNavigation').replaceWith(window.megaNav);
        $('body').addClass('megaNav');
      } else {
        nx = 0;
        customNavStructure();
        $('body').addClass('megaNav');
      }
    }
    if ($('body').hasClass('saffireMobileSize')) {
      nx = 1;
    }
  }

  $(window).load(function() {
    handleNav();
  });

  $(window).resize(function() {
    if ($('body').hasClass('saffireLargeSize')) {
      if (!$('body').hasClass('megaNav')) {
        handleNav();
        console.log('nav switched to mega')
      }
    }
    if ($('body').hasClass('saffireMobileSize')) {
      if ($('body').hasClass('megaNav')) {
        $('#mainNavigation').replaceWith(window.defaultNav);
        $('body').removeClass('megaNav');
        console.log('nav switched to default')
      }
    }
  });



  $(".generalmessage").prependTo(".header");
  //prepend general message into header
  if ($("body").hasClass("generalMessageOn")) {
    $(".generalmessage").prependTo(".header");
  }

  // footer logo
  $('.footer .saffire_logo').attr('src', FULLCLIENTTHEMEPATH + '/images/saffire-logo.png');


});


$(window).load(function () {
   // custom sponsors module stuff
    var i = 1;
    $('.SponsorModule').each(function(){
      if(i==1){
        $(this).addClass('customTopSponsorModule');
        $('.sponsorPageModuleImagebacker', this).css({
          width:'700px',
          height:'auto'
        });
      } else if(i==2){
        $(this).addClass('customSecondSponsorModule');
      } else {
        $(this).addClass('customOtherSponsorModule');
      }
      $('img', this).removeClass('smallImage');
      i++;
      var countImages = $('img', this).length;
      if(countImages == 0){
        $(this).css('opacity','0');
      }
    });

    $('.customTopSponsorModule img').each(function(){
      var getSrc = $(this).attr('data-src');
      getSrc = getSrc.replace('&w=140&h=140', '&w=700&h=250').replace('&cropbox=1&cropboxhpos=center','');
      $(this).attr('data-src', getSrc);
      $(this).attr('src', getSrc);
    });

    $('.customSecondSponsorModule img').each(function(){
      var getSrc = $(this).attr('data-src');
      getSrc = getSrc.replace('&w=140&h=140', '&w=200&h=190').replace('&cropbox=1&cropboxhpos=center','');
      $(this).attr('data-src', getSrc);
      $(this).attr('src', getSrc);
    });

    $('.customOtherSponsorModule img').each(function(){
      var getSrc = $(this).attr('data-src');
      getSrc = getSrc.replace('&w=140&h=140', '&w=110&h=110').replace('&cropbox=1&cropboxhpos=center','');
      $(this).attr('data-src', getSrc);
      $(this).attr('src', getSrc);
    });



});


$(window).resize(function () {

  if ($(window).width() < 801) {
    $('.countdown-wrapper').prependTo('.countdown-container');
    $('#cardWidgetButton').prependTo('.navigation-container');
    $('body:not(.homepage) .countdown-wrapper').insertAfter('.navigation-container');

  } else {
    $('.countdown-wrapper').prependTo('.header-right');
    $('#cardWidgetButton').insertBefore('.mobile-nav-toggle');
    $('body:not(.homepage) .countdown-wrapper').prependTo('.header-right');
  }
});
$(window).load(function () {
  $('body').addClass('pageIsLoaded');

  $('.event-id-0 .hero-wrapper .event-title').text('Event Calendar');
});